import { Outlet } from "react-router-dom";
import {
  LayoutDashboard, Shield, Search, Brain, Share2,
  FileText, Activity, Users, Eye,
} from "lucide-react";
import HubSidebar from "@/components/HubSidebar";


import TopNav from "@/components/TopNav"
import HubSwitcher from "@/components/HubSwitcher";
const NAV_ITEMS = [
  { id: "dashboard", label: "Dashboard", icon: LayoutDashboard, path: "/evet/dashboard", description: "eVET KPI overview" },
  { id: "collector", label: "Collector", icon: Search, path: "/evet/collector", description: "Data ingestion & anomaly detection" },
  { id: "screener", label: "Screener", icon: Shield, path: "/evet/screener", description: "Risk scoring & triage" },
  { id: "interrogator", label: "Interrogator", icon: Brain, path: "/evet/interrogator", description: "Interview co-pilot & contradictions" },
  { id: "connector", label: "Connector", icon: Share2, path: "/evet/connector", description: "Knowledge graph & link analysis" },
  { id: "clerk", label: "Clerk", icon: FileText, path: "/evet/clerk", description: "SOR generation & redaction" },
  { id: "sentinel", label: "Sentinel", icon: Activity, path: "/evet/sentinel", description: "Continuous monitoring" },
  { id: "audit", label: "Audit", icon: Eye, path: "/evet/audit", description: "Audit trail & guardrails" },
];

export default function EVETLayout() {
  return (
    <>
    <TopNav />
    <div className="min-h-screen bg-app flex flex-col md:flex-row">
      <HubSidebar
        navItems={NAV_ITEMS}
        title="AllBaise eVET Hub"
        subtitle="Vetting & Clearance Platform"
        icon={Shield}
        gradient="from-indigo-700 to-purple-700"
        activeBg="bg-indigo-600"
      />
      <main className="flex-1 overflow-auto flex">
        <div className="flex-1 min-w-0 p-4">
          <Outlet />
        </div>
        <div className="hidden lg:block w-40 shrink-0 p-3 border-l border-app">
          <HubSwitcher />
        </div>
      </main>
    </div>
    </>
  );
}
